import { BookmarkBtn } from '@playbooks/components/bookmark/bookmark-btn';
import { OwnerAvatar } from '@playbooks/components/owner/owner-avatar';
import { Badge } from '@playbooks/ui/components/badge';
import { Button } from '@playbooks/ui/components/button';
import { Icon } from '@playbooks/ui/components/icon';
import { Link } from '@playbooks/ui/components/link';
import { formatDate, toShortNumber } from '@playbooks/utils';

import { TemplateRemixBtn } from 'components/template/template-remix-btn';
import { useWorkspace } from 'contexts';

const TemplateMarketplaceHeader = ({ template, compact = false, onClose = null }) => {
	const workspace = useWorkspace();
	const rootApi = `/templates/${template.uuid}`;
	const secureApi = `${workspace.rootApi}/templates/${template.uuid}`;
	const deploy = template.deploy || {};

	return (
		<header className='flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between'>
			<div className='min-w-0'>
				<Badge variant='outline' className='mb-2'>
					Project Template
				</Badge>
				<h1 className={compact ? 'type-heading truncate' : 'type-page-title truncate'}>{template.name || 'Project'}</h1>
				<div className='flex flex-wrap items-center gap-2 pt-1 text-xs text-foreground-subtle'>
					<OwnerAvatar layout='meta' owner={template.owner || {}} href={template.owner?.appPath || ''} />
					<span>·</span>
					<span>{toShortNumber(template.stats?.totalRemixes || 0)} remixes</span>
					{template.updatedAt ? <span>· Updated {formatDate(template.updatedAt, 'MMM D')}</span> : null}
					{deploy.currentRelease?.uuid ? <span>· {deploy.currentRelease.uuid}</span> : null}
				</div>
			</div>
			<div className='flex shrink-0 items-center gap-2'>
				<BookmarkBtn variant='outline' model={template} rootApi={secureApi} />
				<Link
					variant='outline'
					prevIcon='arrow-up-right-from-square'
					href={deploy.url || ''}
					target='_blank'
					disabled={!deploy.url}>
					View app
				</Link>
				<TemplateRemixBtn variant='primary' template={template} rootApi={rootApi} />
				{onClose ? (
					<Button variant='ghost' size='icon' aria-label='Close preview' onClick={onClose}>
						<Icon icon='xmark' aria-hidden />
					</Button>
				) : null}
			</div>
		</header>
	);
};

export { TemplateMarketplaceHeader };
